import DashboardLayout from "../../components/DashboardLayout";
import DashboardAdmin from "../../components/DashboardAdmin";

const SuperadminDashboard = () => {
  return (
    <DashboardLayout role="superadmin">
      {/* <h2>Superadmin Dashboard</h2> */}
      <DashboardAdmin />
    </DashboardLayout>
  );
};

export default SuperadminDashboard;
